module.exports = __webpack_public_path__ + "img/Palestra4.94ea4836.jpg";